import type { User } from '@auth0/auth0-spa-js';
import { redirect } from 'react-router';
import { auth0Client } from './auth0Client';
import type { LoginWithRedirectAppState } from './AuthProvider';

/**
 * 認証が必要なページの loader で使用する関数
 * loader は AuthProvider より先に実行されるため、戻り先等を指定した認証要求に使用する
 * 認証が必要な場合は redirect の throw により表現される
 *
 * @param returnTo 戻り先のページ (アプリ内) の path (`/` はじまり)
 */
export async function requireSignedIn(returnTo?: `/${string}`): Promise<User> {
  await auth0Client.checkSession(); // 最新の認証情報の取得
  const user = await auth0Client.getUser();

  if (!user) {
    // セッションの無いブラウザでメールリンクを開いた場合は、ログイン完了後に token 付きの本画面へ戻して統合を再開する
    const appState: LoginWithRedirectAppState = {
      returnTo: returnTo && returnTo.startsWith('/') ? returnTo : undefined,
    };
    await auth0Client.loginWithRedirect<LoginWithRedirectAppState>({
      appState,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/home`,
      },
      openUrl: (url) => {
        // loader より先に進めないために throw する
        throw redirect(url);
      },
    });

    // redirect は throw で行っているため到達しないはずだが、到達した場合は login redirect 自体が失敗しているのと同等として扱う
    throw new Error('認証画面への遷移に失敗');
  }

  return user;
}
